import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useState, useRef} from 'react';
import {Accordion, AccordionTab} from "primereact/accordion";
import {VehicleService} from "../../../services/vehicleService";
import {IVehicle} from "../../../lib/types/types";
import FirmVehicles from "../../clientFirms/firmDetails/invoicing/FirmVehicles";
import {InputText} from "primereact/inputtext";

interface Props {

}

interface VehiclesByClientFirm {
  [key: string] : IVehicle[]
}

const NoTariffVehicles : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const vehicleService = new VehicleService();


    const [originalVehiclesByClientFirm, setOriginalVehiclesByClientFirm] = useState<VehiclesByClientFirm>();
    const [filteredVehiclesByClientFirm, setFilteredVehiclesByClientFirm] = useState<VehiclesByClientFirm>();
    const [filterValue, setFilterValue] = useState<string>();
    const [activeIndex, setActiveIndex] = useState<number | undefined>(0);

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;

            fetchData();
        }
    }, []);

    useEffect(() => {
        if(!originalVehiclesByClientFirm) return;

        if(!filterValue) {
            setFilteredVehiclesByClientFirm(originalVehiclesByClientFirm);
            return;
        }

        const filteredClientFirms = Object.keys(originalVehiclesByClientFirm)
            .filter(key => key.toLowerCase().includes(filterValue.toLowerCase()))
            .reduce((acc, key) => {
                acc[key] = originalVehiclesByClientFirm[key];
                return acc;
            }, {} as VehiclesByClientFirm);

        setFilteredVehiclesByClientFirm(filteredClientFirms);
    }, [filterValue]);

    const fetchData = () => {
        vehicleService.getAllVehiclesWithoutTariffs()
            .then(resp => {
                const vehiclesByClientFirmFormatted = resp.reduce<VehiclesByClientFirm>((acc, el) => {
                    if(el.clientFirmName in acc) {
                        acc[el.clientFirmName].push(el);
                    }else acc[el.clientFirmName] = [el];

                    return acc;
                }, {} as VehiclesByClientFirm);

                setOriginalVehiclesByClientFirm(vehiclesByClientFirmFormatted);
                setFilteredVehiclesByClientFirm(vehiclesByClientFirmFormatted);
            })
            .catch();
    }

    const successfulOperationCb = () => {
        fetchData();
        const activeIndexTemp = activeIndex;
        setActiveIndex(undefined);
        // setTimeout(() => setActiveIndex(activeIndexTemp), 2000);
    }

    const renderAccordionTabs = () => {
        if(!filteredVehiclesByClientFirm) return;
        return Object.values(filteredVehiclesByClientFirm).filter((el: IVehicle[]) => el.length > 0).map((vehicles: IVehicle[]) => {
            const currentClientFirm = vehicles[0].clientFirmId;
            return <AccordionTab header={`${vehicles[0].clientFirmName} - ${vehicles.length} ${f({id: "vehicles"})}`}>
                <FirmVehicles selectVehicle={() => 0} clientFirmId={currentClientFirm}
                              vehicles={vehicles} successfulOperation={successfulOperationCb} />
            </AccordionTab>
        })
    }

    return <>
        <InputText className={"p-3 my-3"} value={filterValue} onChange={(e) => setFilterValue(e.target.value)} placeholder={f({id: "filterClientFirmName"})}/>
        <Accordion activeIndex={activeIndex}>
            {renderAccordionTabs()}
        </Accordion>
    </>
};

export default NoTariffVehicles
